// General and authentification

//export const CLIENT_ID = 'cN68IW5NQDm86yOi25bCjaPaJ6zS5PQBddKlPT3l';

// export const CLIENT_ID = 'p4LprXhQr1ydUwsr2D2q06zst9ZRYw2RlgIQ82za';
export const CLIENT_ID = '0x0RqkcHuppE8Ikb7VHOC30uePkiLYGa1agFtZKc';
// export const FormId_Adhesion = '1b21fd8f-9785-4879-8301-9c9fe84f652d';
export const FormId_Contact = 'd00fd2ab-7c9c-4ef8-b88b-1d223923edef';
export const FormId_Recrutement='bf16e873-df0c-419e-8486-71c8f8039c03';
export const FormId_ContactTech='b416889b-91fc-465b-9f76-b40fd718541c';
// export const FormId_TestFileSubmission='59c37fbd-7955-400f-bcc3-0024a25b9096';

const HOMEPAGE_URL = 'http://localhost:3000';
//const HOMEPAGE_URL = 'http://optesis.wutiko.com';

const ACCOUNT_SERVER_URL = 'https://accounts1.wutiko.com';
export const LOGOUT_URL = `${ACCOUNT_SERVER_URL}/en/authen/logout/${HOMEPAGE_URL}`;
export const GET_TOKEN_URL = `${ACCOUNT_SERVER_URL}/o/authorize?client_id=${CLIENT_ID}&response_type=token&redirect_uri=${HOMEPAGE_URL}`;

export const RESULTS_PER_PAGE = 20;
export const API_BASE_URL = 'https://api1.wutiko.com';
export const DEFAULT_REQUEST_TIMEOUT = 50000;
export const DEFAULT_AXIOS_PARAMS = {
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: DEFAULT_REQUEST_TIMEOUT,
};



export const LANGUAGE_LIST = ['en', 'fr'];

// Development params

export const DEBUG = true;
export const LANGUAGE_DEBUG = false; // allow to know which i18n keys are missing, but messes the language change



// WEBPACK FOOTER //
// ./src/config.js